import type { BridgeMessageHandler } from '../message-router.js';

/** Server asks CLI to re-scan cwd and send local_skills (same as after bridge_identified). */
export const handleRefreshLocalSkills: BridgeMessageHandler<'refresh_local_skills'> = (_msg, deps) => {
  setImmediate(() => {
    deps.sendLocalSkillsReport?.();
  });
};
